import { get, post, put } from '../actions/method';
import noti from '../actions/toast';
import helper from '../utils/helper';

export async function getTrend(sensorIds, fromDate, toDate) {
  return await get(
    `app/dashboard/trendCharts?SensorIds=${sensorIds}&FromDate=${fromDate}&ToDate=${toDate}`,
  );
}

export async function getAlarmList() {
  return await get('app/dashboard/alerts');
}

export async function getAvailableGroups() {
  return await get('app/dashboard/alertGroupSummaries?MaxResultCount=1000');
}

export async function getCurrentMeasurementValues(groupId) {
  return await get(`app/sensors/measurementValues/${groupId}`);
}

export async function getAvailableGroupsSummaries(groupId) {
  return await get(`app/dashboard/alertGroupSummaries/${groupId}`);
}

export async function setSensorsAtRest(params) {
  return await put(`app/sensors/atRest${helper.compileQueryString(params)}`);
}

export async function setSensorsInOp(params) {
  return await put(
    `app/sensors/inOperation${helper.compileQueryString(params)}`,
  );
}

export async function setSensorsDisable(_params, type = 'group') {
  let params = {
    body: _params,
  };
  return await post(
    `app/sensors/${type === 'group' ? 'disableGroup' : 'disable'}`,
    params,
  )
    .then(() => noti.success(`Sensor(s) is disabled`))
    .catch((error) => noti.error(error.response.data.error.message));
}

export async function setSensorsEnable(params, type = 'group') {
  return await post(
    `app/sensors/${
      type === 'group' ? 'enableGroup' : 'enable'
    }${helper.compileQueryString(params)}`,
  )
    .then(() => noti.success('Sensor(s) is enabled'))
    .catch((error) => noti.error(error.response.data.error.message));
}

export async function getMobileAlarmListByMC(mobileConfigId) {
  if (mobileConfigId) {
    return await get(
      `app/sensors/alarmStatus/by-mobileConfig/${mobileConfigId}`,
    );
  } else {
    return await get(`app/sensors/alarmStatus/current-user`);
  }
}
